import { render } from "./editIdea.vue?vue&type=template&id=32a1d830&scoped=true"
import script from "./editIdea.vue?vue&type=script&lang=js"
export * from "./editIdea.vue?vue&type=script&lang=js"

import "./editIdea.vue?vue&type=style&index=0&id=32a1d830&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a1d830"],['__file',"src/views/aiProduct/components/editIdea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32a1d830"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32a1d830', __exports__)) {
    console.log('reload')
    api.reload('32a1d830', __exports__)
  }
  
  module.hot.accept("./editIdea.vue?vue&type=template&id=32a1d830&scoped=true", () => {
    console.log('re-render')
    api.rerender('32a1d830', render)
  })

}


export default __exports__